import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import debounce from "lodash/debounce"; // You might need to install lodash
import { GamesEndpointUrl } from "../config/consts";
import axios from "axios";
import { GamesCollection, IGame } from "../interfaces/intefaces";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { currentGameAtom, userIsLoggedInAtom } from "../state/games";
import { routes } from "../router/Routes";
import { IconButton } from "@mui/material";
import { ClearIcon, SearchIcon } from "./Icons";
import Icon from "./Icon";

function Search() {
    const [query, setQuery] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [results, setResults] = useState<GamesCollection>();
    const [showResults, setShowResults] = useState(false);
    const [userIsLoggedIn] = useAtom(userIsLoggedInAtom);
    const [, setCurrentGame] = useAtom(currentGameAtom);
    const navigate = useNavigate();
    // Function to handle the search query
    const handleSearch = debounce(async (value: string) => {
        try {
            setLoading(true);
            // Perform AJAX request to fetch search results based on the query
            const url = GamesEndpointUrl;
            const response = await axios.get(url, { params: { nf: value } });
            const data = await response.data;
            setResults(data.data); // Assuming the API returns an array of results
        } catch (error) {
            console.error("Error fetching search results:", error);
        } finally {
            setLoading(false);
            setShowResults(true);
        }
    }, 500); // Debounce time in milliseconds

    // Function to handle input change
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        setQuery(value);
        if (value.length === 0) {
            setResults(undefined);
            setShowResults(false);
        }
        value.length > 2 && handleSearch(value); // Trigger search when input changes
    };

    const clearSearch = () => {
        setResults(undefined);
        setShowResults(false);
        setQuery("");
    };
    const handleGameClick = (game: IGame, userIsLoggedIn: boolean, loginRequired: boolean) => {
        if (!userIsLoggedIn && loginRequired) {
            const el = document.getElementById("login-button");
            if (el !== null) {
                el.click();
            }
            return false;
        }
        setCurrentGame(game);
        const url = new URL(game.url);
        const for_fun_supported = !userIsLoggedIn && game.ffs === 1;
        navigate(
            `${routes.pages.game}?${url.searchParams.toString()}&plat_user=${game.pu}&for_fun=${for_fun_supported}`,
        );
        return true;
    };

    return (
        <div className="games-search">
            <TextField
                placeholder="Search here"
                value={query}
                className={showResults ? "open" : ""}
                onChange={handleChange}
                fullWidth
                size="small"
                InputProps={{
                    endAdornment: (
                        <>
                            {loading && <CircularProgress size={20} />}
                            {!loading && !showResults && (
                                <Icon cssclass="search-icon" icon={SearchIcon} />
                            )}
                            {!loading && showResults && (
                                <IconButton onClick={() => clearSearch()}>
                                    <Icon cssclass="clear-icon" icon={ClearIcon} />
                                </IconButton>
                            )}
                        </>
                    ),
                }}
            />
            <div className={showResults ? "results-wrapper" : "results-wrapper hidden"}>
                <div className="results">
                    {loading && <CircularProgress />}
                    {results?.games.map(game => (
                        <div
                            className="result"
                            key={game.id}
                            onClick={() => handleGameClick(game, userIsLoggedIn, game.ffs === 0)}
                        >
                            <div className="img">
                                <img src={`${game.gmi[0]}/search`} alt={game.pt} />
                            </div>
                            <div className="title">
                                {game.pt}
                                <br />
                                <span>{game.gpn}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Search;
